    <div class="prep-time-modal-title">Preparation Time</div>
    <mat-dialog-content>
    <div class="prep-time-modal-sub">The standard time you allocate for an order.</div>
    <div class="prep-time-modal-value">{{ prepTimeValue }}</div>
    <mat-form-field appearance="fill" class="prep-time-modal-input">
        <mat-label>Input Preparation Time</mat-label>
        <input matInput type="number" min="1" step="1" placeholder="Enter Duration" [(ngModel)]="prepTimeValueInt" />
    </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions class="prep-time-modal-actions">
        <button mat-button color="warn" (click)="discard()">Discard</button>
        <button mat-button color="primary" [disabled]="!prepTimeValueInt || prepTimeValueInt <= 0" (click)="savePrepTime()">Save</button>
    </mat-dialog-actions>
